import React from 'react';
import classNames from 'classnames';

interface DefinitionListProps {
  /** Items to display as DefinitionList. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string | string[];
  /** Header/Caption/Title of the DefinitionList. */
  header?: React.ReactNode;
}

/** Renders a list of items as definitions. */
const DefinitionList = ({
  children,
  className,
  header,
}: DefinitionListProps) => {
  return (
    <div className={classNames(className, 'ce ce-definiton-list')}>
      {header}
      <dl className="row">{children}</dl>
    </div>
  );
};

DefinitionList.defaultProps = {
  className: null,
  header: null,
};

export default DefinitionList;
